import Image from 'next/image';
import React from 'react';

import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';

import { useCitySelectedContext } from '../../../../contexts/city-context/CityContext';
import { CommonImage } from '../../../../shared/types/CommonVM';
import { NewsArticle } from '../../domain/entities/HomeContentEntity';
import { GA_READ_ARTICLE_ACTION } from '../../domain/store/HomeStoreEn';

import styles from '../styles/FeaturedItem.module.scss';

interface FeaturedItemCmpProps {
  news_article: NewsArticle;
  redirect_icon: CommonImage;
  read_article_label: string;
}

function FeaturedItemCmp({
  news_article,
  redirect_icon,
  read_article_label,
}: FeaturedItemCmpProps): React.ReactElement {
  const citySelectedContext = useCitySelectedContext();

  const handleClick = (): void => {
    publishGa4Events(
      citySelectedContext.category,
      news_article.publisher_logo.alt_text + GA_READ_ARTICLE_ACTION,
      news_article.source.href,
    );
  };

  return (
    <div className={styles['featured-item-container']}>
      <div className={styles['description']}>{news_article.content}</div>
      <div className={styles['logo']}>
        <Image
          src={news_article.publisher_logo.path}
          height={51}
          width={464}
          alt={news_article.publisher_logo.alt_text}
          quality={100}
        />
      </div>
      <a
        className={styles['read-article-link']}
        href={news_article.source.href}
        target="_blank"
        rel="noreferrer"
        onClick={handleClick}
      >
        <div className={styles['read-article-title']}>{read_article_label}</div>
        <div className={styles['read-article-outbound-logo']}>
          <Image
            src={redirect_icon.path}
            height={20}
            width={20}
            alt={redirect_icon.alt_text}
            quality={100}
          />
        </div>
      </a>
    </div>
  );
}

export default FeaturedItemCmp;
